"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Select_1 = require("../Select");
var Button_1 = require("../../components/Button");
var ramda_1 = require("../../utils/ramda");
var ErrorBoundary_1 = require("../ErrorBoundary");
require("./Pagination.css");
var R = __importStar(require("../../utils/ramda"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var intl_1 = require("./intl");
var useIntlMock_1 = require("../../utils/useIntlMock");
var validRowsPerPageValues = [10, 25, 50];
var getRowsPerPageOptions = function (rowsPerPageTemplate, intl) {
  return validRowsPerPageValues.map(function (value) {
    var _a;
    return {
      value: value,
      label: (_a = rowsPerPageTemplate === null || rowsPerPageTemplate === void 0 ? void 0 : rowsPerPageTemplate.replace("{0}", value.toString())) !== null && _a !== void 0 ? _a : (0, intl_1.rowPerPageIntl)(value, intl)
    };
  });
};
//@ts-ignore
var getRowsPerPageOption = function (pageValue, rowsPerPageTemplate, intl) {
  return (0, ramda_1.pipe)(
  //@ts-ignore
  (0, ramda_1.groupBy)((0, ramda_1.prop)("value")), (0, ramda_1.prop)(pageValue), ramda_1.head)(getRowsPerPageOptions(rowsPerPageTemplate, intl));
};
var Pagination = function (_a) {
  var _b = _a.numberOfRows,
    numberOfRows = _b === void 0 ? 0 : _b,
    _c = _a.rowsPerPage,
    rowsPerPage = _c === void 0 ? 10 : _c,
    _d = _a.page,
    page = _d === void 0 ? 1 : _d,
    _e = _a.onChange,
    onChange = _e === void 0 ? R.N : _e,
    className = _a.className,
    rowsPerPageTemplate = _a.rowsPerPageTemplate,
    totalRecordsTemplate = _a.totalRecordsTemplate,
    _f = _a.intl,
    intl = _f === void 0 ? (0, useIntlMock_1.useIntlMock)() : _f,
    restProps = __rest(_a, ["numberOfRows", "rowsPerPage", "page", "onChange", "className", "rowsPerPageTemplate", "totalRecordsTemplate", "intl"]);
  var totalRecords = (0, react_1.useMemo)(function () {
    return (0, intl_1.createPaginationIntl)(numberOfRows, intl);
  }, [numberOfRows, intl]).totalRecords;
  var maxPage = Math.ceil(numberOfRows / (rowsPerPage !== null && rowsPerPage !== void 0 ? rowsPerPage : 1)) || 1;
  var handleRowsPerPage = function (_a) {
    var nextRowsPerPage = _a.value;
    var paginationValue = {
      page: 1,
      rowsPerPage: nextRowsPerPage
    };
    onChange(paginationValue);
  };
  var handlePreviousPage = function () {
    var nextPage = page - 1;
    if (nextPage > 0) {
      onChange({
        page: nextPage,
        rowsPerPage: rowsPerPage
      });
    }
  };
  var handleNextPage = function () {
    var nextPage = page + 1;
    if (nextPage <= maxPage) {
      onChange({
        page: nextPage,
        rowsPerPage: rowsPerPage
      });
    }
  };
  var getTranslatedNumberOfRecords = function () {
    var _a;
    return (_a = totalRecordsTemplate === null || totalRecordsTemplate === void 0 ? void 0 : totalRecordsTemplate.replace("{0}", numberOfRows.toString())) !== null && _a !== void 0 ? _a : totalRecords;
  };
  return (0, jsx_runtime_1.jsxs)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-pagination", className)
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-rows-per-page-container"
    }, {
      children: (0, jsx_runtime_1.jsx)(Select_1.Select, {
        name: "rows-per-page",
        value: getRowsPerPageOption(rowsPerPage, rowsPerPageTemplate, intl),
        options: getRowsPerPageOptions(rowsPerPageTemplate, intl),
        onChange: function (v) {
          return handleRowsPerPage(v);
        }
      })
    })), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "vsx-page-control"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Button_1.IconButton, {
        round: true,
        icon: "chevron-left",
        className: "vsx-previous-page",
        onClick: handlePreviousPage
      }), (0, jsx_runtime_1.jsxs)("div", __assign({
        className: "vsx-pagination-paging"
      }, {
        children: [page, "/", maxPage]
      })), (0, jsx_runtime_1.jsx)(Button_1.IconButton, {
        round: true,
        icon: "chevron-right",
        className: "vsx-next-page",
        onClick: handleNextPage
      })]
    })), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-pagination-total-records"
    }, {
      children: getTranslatedNumberOfRecords()
    }))]
  }));
};
exports.Pagination = Pagination;
exports.default = (0, ErrorBoundary_1.withErrorBoundary)(exports.Pagination);